import React, { Component } from 'react';
import { connect, routerRedux } from 'dva';
import { Avatar, Popover } from 'antd';
import { injectIntl } from 'react-intl';

class UserInfo extends Component {
  render() {
    const userMenuOptions = (
      <ul className='gx-user-popover'>
        {/* <li
          onClick={() => {
            this.props.dispatch(
              routerRedux.push({ pathname: `/account/userinfo` })
            );
          }}
        >
          Thông tin
        </li> */}
        {/* <li>Connections</li> */}
        <li
          onClick={() => {
            this.props.dispatch({
              type: 'auth/userSignOut',
            });
          }}
        >
          {this.props.intl.formatMessage({ id: 'app.userAuth.logout' })}
        </li>
      </ul>
    );

    return (
      <>
        <Popover
          overlayClassName='gx-popover-horizantal'
          placement='bottomRight'
          content={userMenuOptions}
          trigger='click'
        >
          <Avatar
            src='https://gravatar.com/avatar/047cd01ffa900b9cb17cde803f0fa515?s=400&d=mp&r=x'
            className='gx-avatar gx-pointer'
            alt=''
          />
        </Popover>
      </>
    );
  }
}

export default connect(null)(injectIntl(UserInfo));
